import { useTranslation } from 'react-i18next';

import { useDeviceDetails } from '@apis/asset-data-service/queries/use-device-details';
import { Stack, Typography } from '@packages/fenrir/components';

import { AssetInformationFieldWrapper } from './asset-information-field-wrapper/asset-information-field-wrapper';

interface AssetInformationSourcesProps {
  assetId: string;
}

export const AssetInformationSources = ({
  assetId,
}: AssetInformationSourcesProps) => {
  const { t } = useTranslation('ads');
  const { data: device } = useDeviceDetails(assetId);
  const { sources } = device ?? {};

  return (
    <AssetInformationFieldWrapper
      assetId={assetId}
      term={t('assetDetails.information.sources')}
      skeletonProps={{ width: '6rem' }}
    >
      {sources?.length ? (
        <Stack>
          {sources.map((source) => (
            <Typography variant="body2" key={source}>
              {t(`source.${source}`)}
            </Typography>
          ))}
        </Stack>
      ) : undefined}
    </AssetInformationFieldWrapper>
  );
};
